import { STEPS } from "./data";
import { Reveal, Eyebrow } from "./Reveal";
import { TapDemo } from "./TapDemo";

export const HowItWorks = () => (
  <section id="cum-functioneaza" data-testid="how-it-works-section" className="relative mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-36">
    <div className="grid lg:grid-cols-12 gap-14 lg:gap-16 items-start">
      <div className="lg:col-span-6">
        <Reveal>
          <Eyebrow>Cum funcționează</Eyebrow>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.02] tracking-[-0.02em]">
            Trei pași. <span className="italic font-black text-[#5FB4E2]">Zero</span> efort.
          </h2>
        </Reveal>
        <ol className="mt-14 space-y-2">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <li data-testid={`step-card-${i + 1}`} className="group grid grid-cols-[auto,1fr] gap-6 border-t border-[#0B1120]/15 py-7">
                <span className="font-mono text-sm text-[#1F6F99] pt-1.5">{s.n}</span>
                <div>
                  <h3 className="font-display text-2xl sm:text-3xl font-medium transition-transform duration-500 group-hover:translate-x-2">{s.title}</h3>
                  <p className="mt-3 text-[#475569] leading-relaxed max-w-md">{s.text}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
      <Reveal delay={0.15} className="lg:col-span-6 lg:sticky lg:top-28">
        <TapDemo />
        <p className="mt-4 text-center text-xs text-[#475569]">Simulare. Încearcă butonul de mai sus.</p>
      </Reveal>
    </div>
  </section>
);
